<template>
  <div>
    <ReceiptQuery v-show="activeKey===1" ref="list" :order-status="orderStatus" :owners="owners" :refundable="refundable" @receive="receive"/>
    <ReceiptEdit v-show="activeKey===2" ref="detail" :order-status="orderStatus" :owners="owners" :refundable="refundable" @back="back"/>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import { getEnums, getOptions } from '@/utils/util'
import ReceiptQuery from '@/views/inbound/receipt/ReceiptQuery'
import ReceiptEdit from '@/views/inbound/receipt/ReceiptEdit.vue'

export default {
  name: 'Receipt',
  components: { ReceiptQuery, ReceiptEdit },
  data() {
    return {
      activeKey: 1,
      orderStatus: [],
      owners: []
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getEnums('OrderStatus')
    }).then(result => {
      this.orderStatus = result
    })
  },
  props: {
    refundable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    receive(row) {
      this.activeKey = 2
      this.$refs.detail.clear()
      this.$refs.detail.refresh(row)
    }
  }
}
</script>